// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
export const SKU_PRICING_DEFAULT_TOAST_ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'left',
} as const;

export const SKU_PRICING_DEFAULT_TOAST_DURATION_MS = 5000;
export const SKU_PRICING_DEFAULT_ERROR_TOAST_MESSAGE =
  'Could not load SKU pricing defaults';
